export default "__VITE_ASSET__30e23348__"